import { render, staticRenderFns } from "./incl-pimCampaignsTable.vue?vue&type=template&id=7b84f2b4&scoped=true"
import script from "./incl-pimCampaignsTable.vue?vue&type=script&lang=js"
export * from "./incl-pimCampaignsTable.vue?vue&type=script&lang=js"
import style0 from "./incl-pimCampaignsTable.vue?vue&type=style&index=0&id=7b84f2b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b84f2b4",
  null
  
)

export default component.exports